export const eth20 = [
  [
    "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    "Wrapped Ether",
    "WETH",
  ],
  [
    "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
    "https://assets.coingecko.com/coins/images/12504/small/uniswap-uni.png?1600306604",
    "Uniswap",
    "UNI",
  ],
  [
    "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    "USD Coin",
    "USDC",
  ],
  [
    "0xdac17f958d2ee523a2206206994597c13d831ec7",
    "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    "Tether USD",
    "USDT",
  ],

  [
    "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
    "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744",
    "Wrapped BTC",
    "WBTC",
  ],
  [
    "0x514910771af9ca656af840dff83e8264ecf986ca",
    "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png?1547034700",
    "Chainlink Token",
    "LINK",
  ],

  [
    "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
    "https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png?1624446912",
    "",
    "",
  ],
];

export const hrc20 = [
  [
    "0xcF664087a5bB0237a0BAd6742852ec6c8d69A27a",
    "https://firebasestorage.googleapis.com/v0/b/defi-kingdoms.appspot.com/o/tokens%2FWONE.png?alt=media",
    "Wrapped ONE",
    "WONE",
  ],
  [
    "0x72Cb10C6bfA5624dD07Ef608027E366bd690048F",
    "https://firebasestorage.googleapis.com/v0/b/defi-kingdoms.appspot.com/o/tokens%2FJEWEL.png?alt=media",
    "Jewels",
    "JEWEL",
  ],
  [
    "0x985458E523dB3d53125813eD68c274899e9DfAb4",
    "https://firebasestorage.googleapis.com/v0/b/defi-kingdoms.appspot.com/o/tokens%2F1USDC.png?alt=media",
    "USD Coin",
    "1USDC",
  ],
  [
    "0x3c2b8be99c50593081eaa2a724f0b8285f5aba8f",
    "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    "Tether USD",
    "1USDT",
  ],

  [
    "0xef977d2f931c1978db5f6747666fa1eacb0d0339",
    "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
    "Dai Stablecoin",
    "1DAI",
  ],
  [
    "0xe176ebe47d621b984a73036b9da5d834411ef734",
    "https://assets.coingecko.com/coins/images/9576/small/BUSD.png?1568947766",
    "Binance USD",
    "BUSD",
  ],
  [
    "0xb82307ff75f0cd2cfc253ba2621851fd9123a818",
    "https://assets.coingecko.com/coins/images/15462/small/ust.png?1620910058",
    "Wrapped UST Token",
    "bscUST",
  ],

  [
    "0x3095c7557bcb296ccc6e363de01b760ba031f2d9",
    "https://firebasestorage.googleapis.com/v0/b/defi-kingdoms.appspot.com/o/tokens%2F1WBTC.png?alt=media",
    "Wrapped BTC",
    "1WBTC",
  ],
  [
    "0x6983d1e6def3690c4d616b13597a09e6193ea013",
    "https://firebasestorage.googleapis.com/v0/b/defi-kingdoms.appspot.com/o/tokens%2F1ETH.png?alt=media",
    "ETH",
    "1ETH",
  ],
  [
    "0x218532a12a389a4a92fc0c5fb22901d1c19198aa",
    "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png?1547034700",
    "ChainLink Token",
    "LINK",
  ],
  [
    "0x301259f392b551ca8c592c9f676fcd2f9a0a84c5",
    "https://cryptologos.cc/logos/polygon-matic-logo.png?v=014",
    "Matic Token",
    "1MATIC",
  ],

  [
    "0x95CE547D730519A90dEF30d647F37D9E5359B6Ae",
    "https://firebasestorage.googleapis.com/v0/b/defi-kingdoms.appspot.com/o/tokens%2FLUNA.png?alt=media",
    "Wrapped LUNA Token",
    "LUNA",
  ],
  [
    "0x735aBE48e8782948a37C7765ECb76b98CdE97B0F",
    "https://cryptologos.cc/logos/fantom-ftm-logo.png?v=014",
    "Fantom",
    "FTM",
  ],
  [
    "0xb12c13e66AdE1F72f71834f2FC5082Db8C091358",
    "https://cryptologos.cc/logos/avalanche-avax-logo.png?v=014",
    "Avalanche",
    "AVAX",
  ],
  [
    "0xcf323aad9e522b93f11c352caa519ad0e14eb40f",
    "https://assets.coingecko.com/coins/images/12645/small/AAVE.png?1601374110",
    "Aave Token",
    "1AAVE",
  ],
  [
    "0x90d81749da8867962c760414c1c25ec926e889b6",
    "https://assets.coingecko.com/coins/images/12504/small/uniswap-uni.png?1600306604",
    "1UNI",
    "Uniswap",
  ],
  [
    "0xbec775cb42abfa4288de81f387a9b1a3c4bc552a",
    "https://assets.coingecko.com/coins/images/12271/small/512x512_Logo_no_chop.png?1606986688",
    "1SUSHI",
    "SushiToken",
  ],
  [
    "0x58f1b044d8308812881a1433d9bbeff99975e70c",
    "https://assets.coingecko.com/coins/images/13469/small/1inch-token.png?1608803028",
    "1INCH Token",
    "11INCH",
  ],

  [
    "0x24eA0D436d3c2602fbfEfBe6a16bBc304C963D04",
    "https://dfk-hv.b-cdn.net/art-assets/items/gaias-tear.png",
    "Gaia's Tears",
    "DFKTEARS",
  ],
  [
    "0x3a4edcf3312f44ef027acfd8c21382a5259936e7",
    "https://dfk-hv.b-cdn.net/art-assets/items/gold-bag.png",
    "Gold",
    "DFKGOLD",
  ],
  [
    "0x6e1bC01Cc52D165B357c42042cF608159A2B81c1",
    "https://dfk-hv.b-cdn.net/art-assets/items/ambertaffy.png",
    "Ambertaffy",
    "DFKAMBRTFY",
  ],
  [
    "0x68EA4640C5ce6cC0c9A1F17B7b882cB1cBEACcd7",
    "https://dfk-hv.b-cdn.net/art-assets/items/darkweed.png",
    "Darkweed",
    "DFKDRKWD",
  ],
  [
    "0x600541aD6Ce0a8b5dae68f086D46361534D20E80",
    "https://dfk-hv.b-cdn.net/art-assets/items/goldvein.png",
    "Goldvein",
    "DFKGLDVN",
  ],
  [
    "0x043F9bd9Bb17dFc90dE3D416422695Dd8fa44486",
    "https://dfk-hv.b-cdn.net/art-assets/items/ragweed.png",
    "Ragweed",
    "DFKRGWD",
  ],
  [
    "0x094243DfABfBB3E6F71814618ace53f07362a84c",
    "https://dfk-hv.b-cdn.net/art-assets/items/redleaf.png",
    "Redleaf",
    "DFKRDLF",
  ],
  [
    "0x6B10Ad6E3b99090De20bF9f95F960addC35eF3E2",
    "https://dfk-hv.b-cdn.net/art-assets/items/rockroot.png",
    "Rockroot",
    "DFKRCKRT",
  ],
  [
    "0xCdfFe898E687E941b124dfB7d24983266492eF1d",
    "https://dfk-hv.b-cdn.net/art-assets/items/swift-thistle.png",
    "Swift-Thistle",
    "DFKSWFTHSL",
  ],
  [
    "0x78aED65A2Cc40C7D8B0dF1554Da60b38AD351432",
    "https://dfk-hv.b-cdn.net/art-assets/items/bloater.png",
    "Bloater",
    "DFKBLOATER",
  ],
  [
    "0xe4Cfee5bF05CeF3418DA74CFB89727D8E4fEE9FA",
    "https://dfk-hv.b-cdn.net/art-assets/items/ironscale.png",
    "Ironscale",
    "DFKIRONSCALE",
  ],
  [
    "0x8Bf4A0888451C6b5412bCaD3D9dA3DCf5c6CA7BE",
    "https://dfk-hv.b-cdn.net/art-assets/items/lanterneye.png",
    "Lantern-Eye",
    "DFKLANTERNEYE",
  ],
  [
    "0xc5891912718ccFFcC9732D1942cCD98d5934C2e1",
    "https://dfk-hv.b-cdn.net/art-assets/items/redgill.png",
    "Redgill",
    "DFKREDGILL",
  ],
  [
    "0xb80A07e13240C31ec6dc0B5D72Af79d461dA3A70",
    "https://dfk-hv.b-cdn.net/art-assets/items/sailfish.png",
    "Sailfish",
    "DFKSAILFISH",
  ],
  [
    "0x372CaF681353758f985597A35266f7b330a2A44D",
    "https://dfk-hv.b-cdn.net/art-assets/items/shimmerskin.png",
    "Shimmerskin",
    "DFKSHIMMERSKIN",
  ],
  [
    "0x2493cfDAcc0f9c07240B5B1C4BE08c62b8eEff69",
    "https://dfk-hv.b-cdn.net/art-assets/items/silverfin.png",
    "Silverfin",
    "DFKSILVERFIN",
  ],
  [
    "0x66F5BfD910cd83d3766c4B39d13730C911b2D286",
    "https://dfk-hv.b-cdn.net/art-assets/items/shvas-rune.gif",
    "Shvas rune",
    "DFKSHVAS",
  ],
  [
    "0x9678518e04Fe02FB30b55e2D0e554E26306d0892",
    "https://dfk-hv.b-cdn.net/art-assets/items/pet-egg-blue.png",
    "Blue Egg",
    "DFKBLUEEGG",
  ],
  [
    "0x95d02C1Dc58F05A015275eB49E107137D9Ee81Dc",
    "https://dfk-hv.b-cdn.net/art-assets/items/pet-egg-grey.png",
    "Grey Egg",
    "DFKGREGG",
  ],
  [
    "0x9edb3Da18be4B03857f3d39F83e5C6AAD67bc148",
    "https://dfk-hv.b-cdn.net/art-assets/items/pet-egg-golden.gif",
    "Golden Egg",
    "DFKGOLDEGG",
  ],
  [
    "0x27dC6AaaD95580EdF25F8B9676f1B984e09e413d",
    "https://dfk-hv.b-cdn.net/art-assets/items/atonement-crystal.gif",
    "Atonement Crystal",
    "DFKLATONECR",
  ],
  [
    "0x1f3F655079b70190cb79cE5bc5AE5F19dAf2A6Cf",
    "https://dfk-hv.b-cdn.net/art-assets/items/atonement-crystal-lesser.gif",
    "Lesser Atonement Crystal",
    "DFKLATONECR",
  ],

  [
    "0x6D4f4bC32df561a35C05866051CbE9C92759Da29",
    "https://dfk-hv.b-cdn.net/art-assets/items/chaos-stone-lesser.gif",
    "Lesser Chaos Stone",
    "DFKLCHSST",
  ],
  [
    "0x2789F04d22a845dC854145d3c289240517f2BcF0",
    "https://dfk-hv.b-cdn.net/art-assets/items/health-potion.png",
    "Health",
    "DFKHLTHPTN",
  ],
  [
    "0x87361363A75c9A6303ce813D0B2656c34B68FF52",
    "https://defi-kingdoms.b-cdn.net/art-assets/items/health-potion-large.png",
    "Full Health",
    "DFKFHLTHPTN",
  ],
  [
    "0x19b020001AB0C12Ffa93e1FDeF90c7C37C8C71ef",
    "https://defi-kingdoms.b-cdn.net/art-assets/items/mana-potion.png",
    "Mana",
    "DFKMNPTN",
  ],
  [
    "0xDc2C698aF26Ff935cD1c50Eef3a4A933C62AF18D",
    "https://defi-kingdoms.b-cdn.net/art-assets/items/mana-potion-large.png",
    "Full Mana",
    "DFKFMNPTN",
  ],
  [
    "0x959ba19508827d1ed2333B1b503Bd5ab006C710e",
    "https://defi-kingdoms.b-cdn.net/art-assets/items/stamina-potion.png",
    "Stamina Potion",
    "DFKSTMNPTN",
  ],
  [
    "0xA1f8b0E88c51a45E152934686270DDF4E3356278",
    "https://defi-kingdoms.b-cdn.net/art-assets/items/antipoison-potion.png",
    "Anti-Poison Potion",
    "DFKANTPSN",
  ],
  [
    "0x872dD1595544CE22ad1e0174449C7ECE6F0bb01b",
    "https://defi-kingdoms.b-cdn.net/art-assets/items/blindness-potion.png",
    "Anti-Blind Potion",
    "DFKANTBLND",
  ],
  [
    "0x1771dEc8D9A29F30d82443dE0a69e7b6824e2F53",
    "https://defi-kingdoms.b-cdn.net/art-assets/items/swiftness-potion.png",
    "Swiftness Potion",
    "DFKSWFTPTN",
  ],
  [
    "0xFb03c364969a0bB572Ce62b8Cd616A7DDEb4c09A",
    "https://defi-kingdoms.b-cdn.net/art-assets/items/toughness-potion.png",
    "Toughness Potion",
    "DFKTFNSPTN",
  ],
  [
    "0x7e120334D9AFFc0982719A4eacC045F78BF41C68",
    "https://defi-kingdoms.b-cdn.net/art-assets/items/magic-resist-potion.png",
    "Magic Resistance Potion",
    "DFKMGCRSPTN",
  ],
];

export const frc20 = [
  [
    "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83",
    "https://assets.coingecko.com/coins/images/16036/small/Fantom.png?1622679930",
    "Wrapped Fantom",
    "WFTM",
  ],
  [
    "0x841fad6eae12c286d1fd18d1d525dffa75c7effe",
    "https://assets.coingecko.com/coins/images/15223/small/logo_200x200.png?1621992076",
    "SpookyToken",
    "Boo",
  ],

  [
    "0x04068da6c83afcfa0e13ba15a6696662335d5b75",
    "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    "USD Coin",
    "USDC",
  ],
  [
    "0x049d68029688eabf473097a2fc38ef61633a3c7a",
    "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    "Frapped USDT",
    "fUSDT",
  ],
  [
    "0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e",
    "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
    "Dai Stablecoin",
    "DAI",
  ],
  [
    "0x82f0b8b456c1a451378467398982d4834b6829c1",
    "https://assets.coingecko.com/coins/images/16786/small/mimlogopng.png?1624979612",
    "Magic Internet Money",
    "MIM",
  ],
  [
    "0x321162cd933e2be498cd2267a90534a804051b11",
    "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744",
    "Bitcoin",
    "BTC",
  ],
  [
    "0x74b23882a30290451a17c44f4f05243b6b58c76d",
    "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    "Ethereum",
    "ETH",
  ],
  [
    "0xd67de0e0a0fd7b15dc8348bb9be742f3c5850454",
    "https://assets.coingecko.com/coins/images/12591/small/binance-coin-logo.png?1600947313",
    "Binance",
    "BNB",
  ],
  [
    "0x511d35c52a3c244e7b8bd92c0c297755fbd89212",
    "https://assets.coingecko.com/coins/images/15075/small/wrapped-avax.png?1629873618",
    "Avalanche",
    "AVAX",
  ],
  [
    "0x1e4f97b9f9f913c46f1632781732927b9019c68b",
    "https://assets.coingecko.com/coins/images/12124/small/Curve.png?1597369484",
    "Curve DAO",
    "CRV",
  ],
  [
    "0x468003b688943977e6130f4f68f23aad939a1040",
    "https://assets.coingecko.com/coins/images/15861/small/abracadabra-3.png?1622544862",
    "Spell Token",
    "SPELL",
  ],
  [
    "0x9fb9a33956351cf4fa040f65a13b835a3c8764e3",
    "https://assets.coingecko.com/coins/images/22087/small/1_Wyot-SDGZuxbjdkaOeT2-A.png?1640764238",
    "Multichain",
    "MULTI",
  ],
  [
    "0x6c021ae822bea943b2e66552bde1d2696a53fbb7",
    "https://assets.coingecko.com/coins/images/16133/small/tomb_icon_noBG.png?1623055476",
    "TOMB",
    "TOMB",
  ],
  [
    "0x4cdf39285d7ca8eb3f090fda0c069ba5f4145b37",
    "https://assets.coingecko.com/coins/images/16405/small/crypto_tomb_share.bf1a6c52.png?1623917558",
    "TSHARE",
    "TSHARE",
  ],
  [
    "0xc54a1684fd1bef1f077a336e6be4bd9a3096a6ca",
    "https://assets.coingecko.com/coins/images/22313/small/VKF8hjD0_400x400.jpg?1641452256",
    "2SHARE Token",
    "2SHARES",
  ],

  [
    "0x7a6e4e3cc2ac9924605dca4ba31d1831c84b44ae",
    "https://assets.coingecko.com/coins/images/22311/small/VKF8hjD0_400x400.jpg?1641452107",
    "2omb Tokens",
    "2OMB",
  ],

  [
    "0xc165d941481e68696f43ee6e99bfb2b23e0e3114",
    "https://assets.coingecko.com/coins/images/22888/small/rjks-OoT_400x400.jpg?1642827011",
    "0xDAO",
    "OXD",
  ],

  [
    "0xe0654c8e6fd4d733349ac7e09f6f23da256bf475",
    "https://assets.coingecko.com/coins/images/17509/small/output-onlinepngtools_%286%29.png?1628053862",
    "Scream",
    "SCREAM",
  ],
];

export const arc20 = [
  [
    "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
    "https://assets.coingecko.com/coins/images/12559/small/coin-round-red.png?1604021818",
    "Wrapped AVAX",
    "WAVAX",
  ],
  [
    "0x60781c2586d68229fde47564546784ab3faca982",
    "https://raw.githubusercontent.com/pangolindex/tokens/main/assets/0x60781C2586D68229fde47564546784ab3fACA982/logo.png",
    "Pangolin",
    "PNG",
  ],
  [
    "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
    "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    "USD Coin",
    "USDC",
  ],
  [
    "0xc7198437980c041c805a1edcba50c1ce5db95118",
    "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    "Tether USD",
    "USDT.e",
  ],
  [
    "0xd586e7f844cea2f87f50152665bcbc2c279d8d70",
    "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
    "Dai Stablecoin",
    "DAI.e",
  ],
  [
    "0x50b7545627a5162f82a992c33b87adc75187b218",
    "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744",
    "Wrapped BTC",
    "WBTC.e",
  ],
  [
    "0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab",
    "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    "Wrapped Ether",
    "WETH.e",
  ],
  [
    "0xce1bffbd5374dac86a2893119683f4911a2f7814",
    "https://assets.coingecko.com/coins/images/15861/small/abracadabra-3.png?1622544862",
    "Spell Token",
    "SPELL",
  ],
];

export const prc20 = [
  [
    "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    "https://assets.coingecko.com/coins/images/14073/small/matic.png?1628852392",
    "Wrapped Matic",
    "WMATIC",
  ],
  [
    "0x831753dd7087cac61ab5644b308642cc1c33dc13",
    "https://assets.coingecko.com/coins/images/13970/small/1_pOU6pBMEmiL-ZJVb0CYRjQ.png?1613386659",
    "Quickswap",
    "QUICK",
  ],
  [
    "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
    "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    "USD Coin (PoS)",
    "USDC",
  ],
  [
    "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    "(PoS) Tether USD",
    "USDT",
  ],
  [
    "0x8f3cf7ad23cd3cadbd9735aff958023239c6a063",
    "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
    "(PoS) Dai Stablecoin",
    "DAI",
  ],
  [
    "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
    "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744",
    "(PoS) Wrapped BTC",
    "WBTC",
  ],
  [
    "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
    "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    "Wrapped Ether",
    "WETH",
  ],
];

export const bsc20 = [
  [
    "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    "https://assets.coingecko.com/coins/images/12591/small/binance-coin-logo.png?1600947313",
    "Wrapped BNB",
    "WBNB",
  ],
  [
    "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
    "https://assets.coingecko.com/coins/images/12632/small/pancakeswap-cake-logo_%281%29.png?1629359065",
    "PancakeSwap Token",
    "Cake",
  ],
  [
    "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    "USD Coin",
    "USDC",
  ],
  [
    "0x55d398326f99059ff775485246999027b3197955",
    "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    "Tether USD",
    "USDT",
  ],
  [
    "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
    "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
    "Dai Token",
    "DAI",
  ],
  [
    "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
    "https://assets.coingecko.com/coins/images/14108/small/Binance-bitcoin.png?1617332330",
    "BTCB Token",
    "BTCB",
  ],
  [
    "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
    "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    "Ethereum Token",
    "ETH",
  ],
  [
    "0xcc42724c6683b7e57334c4e856f4c9965ed682bd",
    "https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png?1624446912",
    "Matic Token",
    "MATIC",
  ],
  [
    "0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe",
    "https://assets.coingecko.com/coins/images/15458/small/ryyrCapt_400x400.jpg?1620895978",
    "XRP Token",
    "XRP",
  ],

  [
    "0x3ee2200efb3400fabb9aacf31297cbdd1d435d47",
    "https://assets.coingecko.com/coins/images/15455/small/ZE8LxNBf_400x400.jpg?1620894681",
    "Cardano Token",
    "ADA",
  ],
];

export default {
  hrc20,
  frc20,
  arc20,
  prc20,
  bsc20,
  eth20,
};
